import React from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom



export default function LinkBtn({ children, goto, className }) {
  return (
    <Link to={goto}> {/* Use 'to' instead of 'href' */}
      <button className={className}>{children}</button>
    </Link>
  );
}
